import http from "../http-common";

export default class HeroJoin  {
  getHeroJoin(path: string) {
    let url = `/hero-join?path=${path}`;
    return http.get(url);
  }
}
